import React from 'react';
import { TagIcon, FileSpreadsheetIcon, MailIcon } from 'lucide-react';
export function OverwhelmedCreatorMockup() {
  return <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl p-8 w-full border-2 border-red-200" data-id="element-525">
            <div className="relative" data-id="element-526">
                {/* Central stressed emoji */}
                <div className="text-center mb-6" data-id="element-527">
                    <div className="text-7xl mb-2" data-id="element-528">😰</div>
                    <p className="text-sm font-semibold text-gray-700" data-id="element-529">
                        Newsletter Creator
                    </p>
                </div>

                {/* Scattered elements around the creator */}
                <div className="space-y-4" data-id="element-530">
                    {/* Tags floating around */}
                    <div className="flex flex-wrap gap-2 justify-center mb-4" data-id="element-531">
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform -rotate-3" data-id="element-532">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-533" />
                            <span className="text-gray-600" data-id="element-534">tag_buyer_2023</span>
                        </div>
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform rotate-2" data-id="element-535">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-536" />
                            <span className="text-gray-600" data-id="element-537">interested_product_a</span>
                        </div>
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform -rotate-1" data-id="element-538">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-539" />
                            <span className="text-gray-600" data-id="element-540">clicked_link_may</span>
                        </div>
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform rotate-3" data-id="element-541">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-542" />
                            <span className="text-gray-600" data-id="element-543">segment_xyz</span>
                        </div>
                    </div>

                    {/* Spreadsheet mockup */}
                    <div className="bg-white rounded-lg border-2 border-gray-300 p-4 shadow-md transform -rotate-1" data-id="element-544">
                        <div className="flex items-center mb-2" data-id="element-545">
                            <FileSpreadsheetIcon className="w-4 h-4 text-green-600 mr-2" data-id="element-546" />
                            <span className="text-xs font-semibold text-gray-700" data-id="element-547">
                                subscriber_tags_final_v3.csv
                            </span>
                        </div>
                        <div className="space-y-1" data-id="element-548">
                            <div className="grid grid-cols-3 gap-2 text-xs" data-id="element-549">
                                <div className="bg-gray-100 p-1 font-semibold text-gray-600" data-id="element-550">
                                    Email
                                </div>
                                <div className="bg-gray-100 p-1 font-semibold text-gray-600" data-id="element-551">
                                    Tag1
                                </div>
                                <div className="bg-gray-100 p-1 font-semibold text-gray-600" data-id="element-552">
                                    Tag2
                                </div>
                            </div>
                            <div className="grid grid-cols-3 gap-2 text-xs text-gray-500" data-id="element-553">
                                <div className="p-1 truncate" data-id="element-554">user@email.com</div>
                                <div className="p-1" data-id="element-555">???</div>
                                <div className="p-1" data-id="element-556">???</div>
                            </div>
                            <div className="grid grid-cols-3 gap-2 text-xs text-gray-500" data-id="element-557">
                                <div className="p-1 truncate" data-id="element-558">another@email.com</div>
                                <div className="p-1" data-id="element-559">???</div>
                                <div className="p-1" data-id="element-560">???</div>
                            </div>
                        </div>
                    </div>

                    {/* Generic blast email mockup */}
                    <div className="bg-white rounded-lg border-2 border-gray-300 p-4 shadow-md transform rotate-2" data-id="element-561">
                        <div className="flex items-center mb-3" data-id="element-562">
                            <MailIcon className="w-4 h-4 text-blue-600 mr-2" data-id="element-563" />
                            <span className="text-xs font-semibold text-gray-700" data-id="element-564">
                                Generic Blast Email
                            </span>
                        </div>
                        <div className="space-y-2" data-id="element-565">
                            <div className="text-xs font-semibold text-gray-800" data-id="element-566">
                                Subject: Weekly Newsletter
                            </div>
                            <div className="text-xs text-gray-600 leading-relaxed" data-id="element-567">
                                <p className="mb-1" data-id="element-568">Hi Everyone,</p>
                                <p className="mb-1" data-id="element-569">
                                    Here's this week's content for ALL subscribers...
                                </p>
                                <p className="text-gray-400 italic" data-id="element-570">
                                    Same message • Same offers • No personalization
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom text */}
                <div className="mt-6 text-center" data-id="element-571">
                    <p className="text-sm font-semibold text-red-700" data-id="element-572">
                        Manual tagging chaos
                    </p>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-573">
                        Hours wasted • Generic content • Lost revenue
                    </p>
                </div>
            </div>
        </div>;
}